import React from 'react';
import PropTypes from 'prop-types';
import styled from "styled-components";
import { FaGithub } from 'react-icons/fa';


function GitHubSetupProgress({ currentStep, totalSteps, labels = [] }) {
  const steps = Array.from({ length: totalSteps }, (_, index) => index + 1);

  return (
    <>
      <Header>
        <HeaderRow>
          <Title>
            <FaGithub size={32} /> GitHub Connection
          </Title>
        </HeaderRow>
      </Header>
      <ProgressWrapper>
        {steps.map((step, index) => (
          <React.Fragment key={step}>
            <ProgressStep>
              <StepNumber $active={currentStep >= step}>{step}</StepNumber>

              {labels[index] && (
                <StepLabel $active={currentStep >= step}>
                  {labels[index]}
                </StepLabel>
              )}
            </ProgressStep>

            {index < steps.length - 1 && <Arrow>→</Arrow>}
          </React.Fragment>
        ))}
      </ProgressWrapper>
    </>
  );
}

GitHubSetupProgress.propTypes = {
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
  labels: PropTypes.arrayOf(PropTypes.string),
};

const Header = styled.div`
text-align: center;
`;


const Title = styled.h1`
    font-size: 2.25rem;
  font-weight: 700;   
  color: #1f2937;  
  margin-bottom: 1rem;  
`;

const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem; /* mb-4 */
`;

const ProgressWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-bottom: 32px;

  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;

  @media (max-width: 640px) {
    gap: 12px;
    margin-bottom: 24px;
  }
`;

const ProgressStep = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
`;

const StepNumber = styled.span`
  width: 32px;
  height: 32px;
  border-radius: 9999px;

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 14px;
  font-weight: 600;

  background-color: ${({ $active }) => ($active ? "#3b82f6" : "#e2e8f0")};
  color: ${({ $active }) => ($active ? "#ffffff" : "#64748b")};

  transition: all 0.25s ease;

  @media (max-width: 640px) {
    width: 28px;
    height: 28px;
    font-size: 12px;
  }
`;

const StepLabel = styled.span`
  font-size: 12px;
  color: ${({ $active }) => ($active ? "#3b82f6" : "#475569")};
  font-weight: ${({ $active }) => ($active ? "700" : "500")};

  text-transform: uppercase;
  letter-spacing: 0.04em;

  @media (max-width: 640px) {
    font-size: 11px;
  }
`;

const Arrow = styled.div`
  color: #cbd5e1;
  font-size: 14px;
  font-weight: 600;
`;

export default GitHubSetupProgress;

